export const LogoMark = ({ className = "w-8 h-8" }) => (
  <svg viewBox="0 0 64 64" className={className} fill="none" aria-hidden="true">
    <rect width="64" height="64" rx="16" fill="#00E676" />
    <path d="M17 20h30v9a6.5 6.5 0 0 0 0 13v9H17v-9a6.5 6.5 0 0 0 0-13v-9z" fill="#070709" />
    <circle cx="35" cy="35.5" r="8" stroke="#00E676" strokeWidth="3.5" />
    <path d="M35 31v4.5l3 2" stroke="#00E676" strokeWidth="3.5" strokeLinecap="round" />
  </svg>
);
